import { Compass } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useI18n } from '../lib/i18n';
import { Card, EmptyState } from '../components/ui';

export function NotFoundPage() {
  const { t } = useI18n();
  return (
    <Card>
      <EmptyState
        icon={<Compass className="h-8 w-8" />}
        title={t('notFound.title')}
        hint={t('notFound.hint')}
        action={
          <Link to="/" className="text-body-sm text-primary-600 dark:text-primary-400 hover:underline">
            {t('nav.dashboard')}
          </Link>
        }
      />
    </Card>
  );
}
